import classNames from 'classnames';
import * as React from 'react';
import { compose, defaultProps, lifecycle, pure, withHandlers, withStateHandlers } from 'recompose';
import { Grid, InputAdornment, TextField } from '@material-ui/core';
import { format } from '@topconagriculture/frontend-utils';
import { Button } from '../../Button';
import useStyles from './PlusMinusInputStyles';
import clamp from 'lodash/clamp';
const PlusMinusInput = (props) => {
    const { addHandler, removeHandler, min, max, currentValue, inputHandler, label, testId = 'PlusMinusInput', meta, postLabel, onFocus, } = props;
    const classes = useStyles();
    const canIncrement = Number(currentValue) !== max;
    const canDecrement = Number(currentValue) !== min;
    return (React.createElement("div", { "data-testid": `${testId}` },
        label ? React.createElement("label", { className: classes.label }, label) : null,
        React.createElement(Grid, { container: true, wrap: "nowrap" },
            React.createElement(Button, { "data-testid": `${testId}-subtrackt`, className: classNames(classes.button, { [classes.buttonDisabled]: !canDecrement }), label: "-", onClick: removeHandler }),
            React.createElement(Grid, { item: true, xs: true, zeroMinWidth: true },
                React.createElement(TextField, { "data-testid": `${testId}-input`, type: "number", className: classNames(classes.textField, { [classes.textFieldInvalid]: meta && meta.invalid }), InputProps: {
                        endAdornment: postLabel && (React.createElement(InputAdornment, { classes: {
                                root: classes.suffix,
                            }, disableTypography: true, position: "start" }, postLabel)),
                        inputProps: { min, max },
                        disableUnderline: true,
                        classes: {
                            input: classes.input,
                        },
                    }, value: currentValue, onChange: inputHandler, onFocus: onFocus })),
            React.createElement(Button, { "data-testid": `${testId}-add`, className: classNames(classes.button, { [classes.buttonDisabled]: !canIncrement }), label: "+", onClick: addHandler }))));
};
export default compose(pure, defaultProps({
    step: 1,
    min: -Infinity,
    max: Infinity,
}), withStateHandlers(({ input, value }) => ({
    currentValue: input ? input.value : value || '',
}), {
    setValue: (state, { min, max, disabled, input }) => (value) => {
        if (disabled) {
            return state;
        }
        if (format.isNumeric(value)) {
            value = parseFloat(value.toString());
            value = clamp(value, min, max);
        }
        else if (value !== '') {
            return {
                currentValue: value,
            };
        }
        if (input) {
            input.onChange(value);
        }
        return {
            currentValue: value,
        };
    },
}), withHandlers({
    inputHandler: ({ setValue }) => (event) => {
        const val = event.currentTarget.value;
        if (format.isNumeric(val) || val === '') {
            setValue(val);
        }
    },
    addHandler: ({ currentValue, step, setValue, disabledValues = [], startValue = 0 }) => () => {
        if (currentValue === '') {
            currentValue = startValue;
        }
        let value = parseFloat(currentValue.toString());
        let isDisabled = false;
        do {
            value += step;
            isDisabled = disabledValues.some((d) => d.toString() === value.toString());
        } while (isDisabled === true);
        setValue(value);
    },
    removeHandler: ({ currentValue, step, setValue, disabledValues = [], startValue = 0 }) => () => {
        if (currentValue === '') {
            currentValue = startValue;
        }
        let value = parseFloat(currentValue.toString());
        let isDisabled = false;
        do {
            value -= step;
            isDisabled = disabledValues.some((d) => d.toString() === value.toString());
        } while (isDisabled === true);
        setValue(value);
    },
}), lifecycle({
    componentDidUpdate(prevProps) {
        var _a, _b;
        const newValue = (_a = (this.props.input ? this.props.input.value : this.props.value)) !== null && _a !== void 0 ? _a : '';
        const prevValue = (_b = (prevProps.input ? prevProps.input.value : prevProps.value)) !== null && _b !== void 0 ? _b : '';
        if (newValue.toString() !== prevValue.toString()) {
            this.props.setValue(format.isNumeric(newValue) ? parseFloat(newValue) : newValue);
        }
    },
}))(PlusMinusInput);
//# sourceMappingURL=PlusMinusInput.js.map